
import { Toolbar, IconButton, Tooltip, Box, Button, Badge } from '@mui/material';
import { useAuthStore, useSidebarStore } from '../../store';
import { AppBar } from '../../theme/yellow';
import { iconos } from '../../data';




export const NavBarScreen = () => {
    

    const { startLogout } = useAuthStore();
    const isSidebarOpen = useSidebarStore( state => state.isSidebarOpen );
    const toggleSidebarOpen = useSidebarStore( state => state.toggleSidebar );



    const handleDrawerOpen = () => {
        toggleSidebarOpen();
    };

    
    const handleLogout = () => {
        startLogout();
    }



    return (
        <AppBar position="fixed" open={isSidebarOpen} theme={undefined}>
            <Toolbar>

                <IconButton sx={{mr:2, color:"#ffffff", bgcolor:'secondary.main'}} onClick={ handleDrawerOpen }>
                    {(isSidebarOpen)
                    ?   iconos['fechaesconder']
                    :   iconos['principal']
                    }
                </IconButton>

                <Box sx={{ flexGrow: 1 }} />


                <Box>
                    <Tooltip title="Cerrar Sección">
                        <Button color='secondary' variant="contained" onClick={ handleLogout } 
                            sx={{color:'white', fontWeight:'bold'}} startIcon={iconos['salir']}
                        > Salir
                        </Button>
                    </Tooltip>
                </Box>
            </Toolbar>
        </AppBar>
    )
}
